import { render, staticRenderFns } from "./BankDocumentList.vue?vue&type=template&id=49df5805&scoped=true&"
import script from "./BankDocumentList.vue?vue&type=script&lang=js&"
export * from "./BankDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df5805",
  null
  
)

export default component.exports